import React from 'react';

const ConfirmModal = ({
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmTone = 'primary',
  busy = false,
  onConfirm,
  onClose,
  children,
}) => (
  <div className="modal" role="dialog" aria-modal="true" aria-labelledby="docs-confirm-title">
    <div className="backdrop" onClick={busy ? undefined : onClose} aria-hidden="true" />
    <div className="modal-content docs-modal-wide">
      <h2 id="docs-confirm-title">{title}</h2>
      {message ? <p className="docs-modal-copy">{message}</p> : null}
      {children}
      <div className="actions">
        <button type="button" onClick={onClose} disabled={busy}>
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={busy}
          className={confirmTone === 'danger' ? 'docs-btn docs-btn--danger' : undefined}
        >
          {busy ? 'Working…' : confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
